import deleteicon from "../../assets/svg/Assetmanagemant/delete_forever.svg";
import Groupiconblue from "../../assets/svg/partitioncontent/blueVideoImg.svg";
import InProgressVideoBlock from "./InProgressVideoBlock";

const VideoThumbnail = ({
  data,
  openplayerdata,
  index,
  deleteFunction,
  permission,
}) => {
  return (
    <>
      {data.copyStatus === 'IN_PROGRESS' ? (
        <InProgressVideoBlock
          data={data}
          permission={permission}
          deleteFunction={deleteFunction}
        />
      ) : (
        <div
          style={{
            background: `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #0F3B47, #36D2FF, #0F3B47) border-box`,
            borderRadius: "6px",
            border: "1px solid transparent",
            padding: "5px",
            transition: " all 0.3s ",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right, #22BBBE, #7DAD41, #F4B719, #E55824, #B52C80) border-box`;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = `linear-gradient(#0D0D0D, #0D0D0D) padding-box, linear-gradient(to right,  #0F3B47, #36D2FF, #0F3B47) border-box`;
          }}
          key={index}
          className="block"
          onDoubleClick={() => {
            openplayerdata(data);
          }}
        >
          <div className="img-block ">
            <img src={Groupiconblue} alt="" />
          </div>

          <div className="text-block">
            <label title={data.filename} className="text-label">
              {data.filename}
            </label>
          </div>
          {permission === "edit" ? (
            <div className="dropdown">
              <button
                onClick={(e) => {
                  // e.stopPropagation();
                  deleteFunction(data.id, e);
                }}
                className="delete-poster "
              >
                <img src={deleteicon} alt="" />
              </button>
            </div>
          ) : (
            ""
          )}
        </div>
      )}
    </>
  );
};

export default VideoThumbnail;
